import moment from 'moment'
import {
  UPDATE_REDFLAG,
  GET_REDFLAG,
  GET_ALL_REDFLAG,
  GET_ALL_OUTOFBUISNESS,
  GET_ALL_CONTACTS,
  GET_CONTACT,
  RESET_CONTACT,
  GET_CONTACTS_DIVISIONS,
  GET_CONTACTS_ADDITIONAL,
  CREATE_CONTACTS_ADDITIONAL,
  UPDATE_CONTACTS_ADDITIONAL,
  GET_COMPANY_TYPE_OPTIONS,
  GET_DIVISIONS_COMBINED,
  SET_LOADER,
  GET_DUPLICATED_CONTACTS,
  GET_CONTACT_DIVISION,
  GET_RELATED_ENTITIES,
  SET_RELATED_ENTITIES_LOADING,
  GET_HISTORY_DATA,
  GET_STATUS_CHANGES,
  CONTACT_ASSIGNED,
  GET_PERSONAL_NOTES,
  LOADING_PERSONAL_NOTES,
  GET_LESSEE,
  CLEAR_LESSEE,
  GET_ALL_LESSEE,
  CONTACT_LOADING,
  CLEAR_CONTACTS,
  RESET_DUPLICATED_CONTACTS,
} from './types'
import { EPIC_ACTIONS } from './EpicActions'

const initialState = {
  contacts: [],
  contactsAdditional: [],
  contact: {},
  contactsDivisions: [],
  contactDivision: {},
  personalNotes: {
    data: [],
    isLoading: false,
  },
  loading: false,
  relatedEntities: {
    query: {},
    data: [],
    isLoading: false,
  },
  historyData: [],
  contractLostData: {
    data: {},
    isLoading: false,
  },
  statusChanges: {
    data: [],
    query: {
      totalRecords: 0,
      limit: 5,
      first: 0,
    },
  },
  contactsRedFlag: {
    data: [],
    query: {
      totalRecords: 0,
      limit: 5,
      first: 0,
    },
  },
  lessee: {
    isSearched: false,
    data: {},
    allLessee: {
      data: [],
      query: {},
    },
  },
  assignedContacts: [],
  epic: {
    data: null,
    isLoading: false,
    error: null,
    lastContactName: null,
  },
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ALL_LESSEE:
      return {
        ...state,
        lessee: {
          ...state.lessee,
          allLessee: action.payload,
        },
      }
    case GET_LESSEE:
      return {
        ...state,
        lessee: {
          isSearched: true,
          data: action.payload,
        },
      }
    case CLEAR_LESSEE:
      return {
        ...state,
        lessee: {
          isSearched: false,
          data: {},
        },
      }
    case GET_STATUS_CHANGES:
      return {
        ...state,
        statusChanges: {
          data: action.payload.data,
          query: action.payload.query,
        },
      }
    case GET_CONTACT_DIVISION:
      return {
        ...state,
        contactDivision: action.payload,
        isLoading: false,
      }
    case UPDATE_REDFLAG:
      return {
        ...state,
        contactsOneRedFlag: action.payload,
      }
    case GET_REDFLAG:
      return {
        ...state,
        contactsOneRedFlag: action.payload,
      }
    case GET_ALL_REDFLAG:
      return {
        ...state,
        contactsRedFlag: action.payload,
      }
    case GET_ALL_OUTOFBUISNESS:
      return {
        ...state,
        contactsOutOfBusiness: action.payload,
      }
    case GET_CONTACTS_DIVISIONS:
      return {
        ...state,
        contactsDivisions: action.payload,
      }
    case GET_CONTACTS_ADDITIONAL:
      return {
        ...state,
        contactsAdditional: action.payload,
      }
    case CREATE_CONTACTS_ADDITIONAL:
      return {
        ...state,
        contactsAdditional: action.payload,
      }
    case UPDATE_CONTACTS_ADDITIONAL:
      return {
        ...state,
        contactsAdditional: action.payload,
      }
    case GET_CONTACT:
      // day behind date display fix for dates
      return {
        ...state,
        contact: {
          ...action.payload,
          dateEstablished: action.payload.dateEstablished
            ? moment
                .utc(moment(action.payload.dateEstablished).utc().format('MM/DD/YYYY')) // drop time (hours, minutes) to prevent bug on multiple time tz was added
                .add(Math.abs(new Date().getTimezoneOffset()), 'm')
                .format('MM/DD/YYYY HH:mm:ss')
            : null,
          effDate: action.payload.effDate
            ? moment
                .utc(moment(action.payload.effDate).utc().format('MM/DD/YYYY')) // drop time (hours, minutes) to prevent bug on multiple time tz was added
                .add(Math.abs(new Date().getTimezoneOffset()), 'm')
                .format('MM/DD/YYYY HH:mm:ss')
            : null,
          expDate: action.payload.expDate
            ? moment
                .utc(moment(action.payload.expDate).utc().format('MM/DD/YYYY')) // drop time (hours, minutes) to prevent bug on multiple time tz was added
                .add(Math.abs(new Date().getTimezoneOffset()), 'm')
                .format('MM/DD/YYYY HH:mm:ss')
            : null,
        },
      }
    case GET_ALL_CONTACTS:
      return {
        ...state,
        contacts: action.payload,
        isLoading: false,
      }
    case RESET_CONTACT:
      return {
        ...state,
        contact: action.payload,
      }
    case CLEAR_CONTACTS:
      return {
        ...state,
        contacts: [],
      }
    case GET_COMPANY_TYPE_OPTIONS:
      return {
        ...state,
        companyTypeOptions: action.payload,
      }
    case GET_DIVISIONS_COMBINED:
      return {
        ...state,
        divisionsCombined: action.payload,
      }
    case GET_DUPLICATED_CONTACTS:
      return {
        ...state,
        duplicatedContacts: action.payload,
      }
    case RESET_DUPLICATED_CONTACTS:
      return {
        ...state,
        duplicatedContacts: null,
      }
    case SET_LOADER:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case SET_RELATED_ENTITIES_LOADING:
      return {
        ...state,
        relatedEntities: {
          ...state.relatedEntities,
          isLoading: !state.relatedEntities.isLoading,
        },
      }
    case GET_RELATED_ENTITIES:
      return {
        ...state,
        relatedEntities: {
          ...action.payload,
          isLoading: false,
        },
      }
    case GET_HISTORY_DATA:
      return {
        ...state,
        historyData: action.payload,
        isLoading: false,
      }
    case GET_PERSONAL_NOTES:
      return {
        ...state,
        personalNotes: {
          data: action.payload,
          isLoading: false,
        },
      }
    case LOADING_PERSONAL_NOTES:
      return {
        ...state,
        personalNotes: {
          ...state.personalNotes,
          isLoading: !state.personalNotes.isLoading,
        },
      }
    case CONTACT_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    case CONTACT_ASSIGNED:
      return {
        ...state,
        assignedContacts: [...state.assignedContacts, ...action.payload],
      }
    // Epic Actions
    case EPIC_ACTIONS.FETCH_EPIC_DATA_REQUEST:
      return {
        ...state,
        epic: {
          ...state.epic,
          isLoading: true,
          error: null,
        },
      }
    case EPIC_ACTIONS.FETCH_EPIC_DATA_SUCCESS:
      return {
        ...state,
        epic: {
          ...state.epic,
          data: action.payload,
          isLoading: false,
          error: null,
          lastContactName: action.payload?.company?.name || null,
        },
      }
    case EPIC_ACTIONS.FETCH_EPIC_DATA_FAILURE:
      return {
        ...state,
        epic: {
          ...state.epic,
          data: null,
          isLoading: false,
          error: action.payload,
          lastContactName: null,
        },
      }
    case EPIC_ACTIONS.CLEAR_EPIC_DATA:
      return {
        ...state,
        epic: {
          data: null,
          isLoading: false,
          error: null,
          lastContactName: null,
        },
      }
    default:
      return state
  }
}
